import React from "react";

import { PricingFeatureTable } from "@/components/wpl/pricing/src/features-table";
import {
    DataCenterSection,
    QuestionsCta
} from "@/components/wpl/pricing/src/index.ts";
import {
    useDatacenterPlans,
    usePricingContentContext
} from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import {
    PricingFaq,
    QuotationsAdornment
} from "@/components/wpl/pricing/src/pricing-faq";
import {
    PricingPageLayout,
    PageHeading
} from "@/components/wpl/pricing/src/pricing-page-layout";
import { BitbucketNav } from "@/templates/software/bitbucket/src/sections/index.ts";
import { CallToAction } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { ParentScrollTracking } from "@/utils/scroll-tracking/parent-scroll-tracker.tsx";

import { SoftwareBitbucketPricingPageProps } from "../../../../../../pages/software/bitbucket/pricing/software-bitbucket-pricing-page";

import { BitbucketPriceFinder } from "./sections/bitbucket-price-finder.tsx";

export const SoftwareBitbucketPricingPageTemplate: React.FC<
    SoftwareBitbucketPricingPageProps
    // eslint-disable-next-line complexity
> = ({ pricing, countryCode }) => {
    const content = usePricingContentContext();
    const dataCenterContent = useDatacenterPlans("Contact Us", "Learn more");
    const questionsCtaContent = content
        ?.callToActionContainer?.[0] as CallToAction;
    return (
        <PricingPageLayout
            nav={<BitbucketNav />}
            showFallback={content?.hasError}
        >
            <ParentScrollTracking pageId="bitbucket-pricing-page">
                <PageHeading>{content?.headline}</PageHeading>
                <BitbucketPriceFinder
                    serverSideHAMSPricing={pricing?.hamsPricingData?.bitbucket}
                    countryCode={countryCode}
                />
                <PricingFeatureTable
                    title={content?.compareFeaturesTitle ?? undefined}
                    comparePlans={content?.comparePlans ?? undefined}
                    compareFeatures={content?.compareFeatures ?? undefined}
                />
                <DataCenterSection {...dataCenterContent} />
                <QuotationsAdornment>
                    <ParentScrollTracking>
                        <PricingFaq
                            header={content?.getMoreDetailsTitle ?? undefined}
                            planDetails={
                                content?.additionalDetails ?? undefined
                            }
                        />
                    </ParentScrollTracking>
                </QuotationsAdornment>
                <QuestionsCta
                    product={"Bitbucket"}
                    ctaHref={questionsCtaContent?.url ?? undefined}
                    questionsHeader={questionsCtaContent?.title ?? undefined}
                    priceAndLicensingLinkText={
                        questionsCtaContent?.text ?? undefined
                    }
                    questionsBody={
                        questionsCtaContent?.valueProposition ?? undefined
                    }
                    imageHref={questionsCtaContent?.asset?.url}
                />
            </ParentScrollTracking>
        </PricingPageLayout>
    );
};
